module.exports = __webpack_public_path__ + "images/6ad83c7b7e927bff0c8f9935aa2711f7.png";